import IndividualList from "./IndividualList";
export default IndividualList;
